try {
    let btnLight = document.getElementById("btnLight");
    let btnDark = document.getElementById("btnDark");
    var btnCharacter = document.getElementsByClassName("btn-shopByCharacter");
    btnLight.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(".collection").classList.remove("bg-darktheme");
      document.querySelector(".collection").classList.add("bg-lighttheme");
      // document.querySelector(".collection_light_content-wrapper").style.display = "block";
      // document.querySelector(".collection_dark_content-wrapper").style.display = "none";
      console.log("light theme");
    });
    btnDark.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(".collection").classList.remove("bg-lighttheme");
      document.querySelector(".collection").classList.add("bg-darktheme");
      // document.querySelector(".collection_light_content-wrapper").style.display = "none";
      // document.querySelector(".collection_dark_content-wrapper").style.display = "block";
    });
  } catch (e) {
    console.log(e.message);
  }